import * as React from "react";
import { Link, Route } from "react-router-dom";
import { Authorization, GlobalAuthorization } from "../misc/components/Authorization";
import { PermissionEnum } from "../misc/api/ApiPermissionEnum";
import UserList from "../Users/List/UserList";
import { DiaryConfigurationsList } from "./Diary/DiaryConfigurationsList";
import { CreateDiaryConfigurationScreen } from "./Diary/CreateDiaryConfiguration";
import { DiaryConfigurationFiles } from "./Diary/DiaryConfigurationFiles";
import { EditDiaryConfigurationScreen } from "./Diary/EditDiaryConfiguration";
import FixedCommentsScreen from "./FixedComments/index";
import EditFixedCommentSetScreen from "./FixedComments/EditFixedCommentSet/EditFixedCommentSet";
import CreateFixedCommentSetScreen from "./FixedComments/CreateFixedCommentSet/CreateFixedCommentSet";
import { VisitSchedule } from "./VisitSchedule/VisitSchedule";
import { DevicesList } from "./Devices/DevicesList";
import { CreateDeviceScreen } from "./Devices/CreateDevice";
import { EditDeviceScreen } from "./Devices/EditDevice";
import { UpdatePackagesList } from "./UpdatePackages/UpdatePackagesList";
import { SiteScreen } from "./Sites/SitesScreen";
import { SupportContactScreen } from "./SupportContact/SupportContactScreen";
import { StudiesScreen } from "./Studies/StudiesScreen";
import { RolesRoot } from "./Roles/RolesRoot";
import { AdminHome } from "./AdminHome";
import { useSecurityContext } from "../Core/SecurityContext";
import { ServiceResourcesList } from "./ServiceResources/ServiceResourcesList";
import { MainState } from "../Core/reducers";
import { connect } from "react-redux";
import { DiarySettings } from "./Studies/Settings/DiarySettings";
import { AccessRequestListScreen } from "./AccessRequests/AccessRequestListScreen";
import { CreateUserScreen } from "../Users/Form/CreateUserScreen";
import { EditUserScreen } from "../Users/Form/EditUserScreen";
import { AssociateUsersWithSites } from "../Users/AssociateUsersWithSites";
import { useAuth } from "react-oidc-context";
import { NotificationsPanel } from "../notifications/NotificationsPanel";
import { CustomCalculationsScreen } from "./Studies/CustomCalculationsScreen";

declare const rootUrl;

export interface AdminMenuLayoutProps {
    currentStudyId: string;
}

export const AdminMenuLayout = ({ currentStudyId }: AdminMenuLayoutProps) => {
    const { currentUserPermissions } = useSecurityContext();

    return (
        <GlobalAuthorization currentPermissions={currentUserPermissions} permissionId={PermissionEnum.AccessAdmin}>
            <div className="row">
                <div className="col-sm-2 hidden-xs no-gutter">
                    <nav className="sidebar-nav">
                        <div className="sidebar-collapse">
                            <ul className="nav">
                                <li className="active">
                                    <span>User &amp; Role Management</span>
                                    <ul aria-expanded="false">
                                        <GlobalAuthorization currentPermissions={currentUserPermissions} permissionId={PermissionEnum.ViewUserManagement}>
                                            <li>
                                                <Link id="requestsLink" to="/requests"><i className="fas fa-user-plus fa-lg"></i>&nbsp;Users Access Requests</Link>
                                            </li>
                                        </GlobalAuthorization>
                                        <Authorization currentPermissions={currentUserPermissions} studyId={currentStudyId} permissionIdsAll={[PermissionEnum.ViewUserManagement,PermissionEnum.ViewUsers]}>
                                            <li>
                                                <Link id="usersLink" to="/users"><i className="fas fa-users fa-lg"></i>&nbsp;Users</Link>
                                            </li>
                                        </Authorization>
                                        <Authorization currentPermissions={currentUserPermissions} studyId={currentStudyId} permissionId={PermissionEnum.ViewRoleManagement}>
                                            <li>
                                                <Link to="/rolemanagement" id="rolesLink"><i className="fas fa-graduation-cap fa-lg"></i>&nbsp;Roles</Link>
                                            </li>
                                        </Authorization>
                                    </ul>
                                </li>
                                <li className="active">
                                    <span>Core Study Administration</span>
                                    <ul aria-expanded="false">
                                        <GlobalAuthorization currentPermissions={currentUserPermissions} permissionId={PermissionEnum.ViewStudies}>
                                            <li><Link id="studiesLink" to="/studies"><i className="fas fa-list-alt fa-lg"></i>&nbsp;Studies</Link></li>
                                        </GlobalAuthorization>
                                        <Authorization currentPermissions={currentUserPermissions} studyId={currentStudyId} permissionId={PermissionEnum.ViewSites}>
                                            <li>
                                                <Link id="sitesLink" to="/Sites"><i className="fas fa-home fa-lg"></i>&nbsp;Sites</Link>
                                            </li>
                                        </Authorization>
                                        <Authorization studyId={currentStudyId} currentPermissions={currentUserPermissions} permissionId={PermissionEnum.ViewNotificationSubscriptions}>
                                        <li>
                                            <Link to="/admin/notifications" id="notificationsLink">
                                                <i className="fas fa-bell fa-lg"></i>&nbsp;
                                                Notifications
                                            </Link>
                                        </li>
                                        </Authorization>
                                        <Authorization studyId={currentStudyId} currentPermissions={currentUserPermissions} permissionId={PermissionEnum.ManageCustomCalculations}>
                                        <li>
                                            <Link to="/admin/customcalculations" id="notificationsLink">
                                                <i className="fas fa-calculator fa-lg"></i>&nbsp;
                                                Custom Calculations
                                            </Link>
                                            </li>
                                        </Authorization>
                                    </ul>
                                </li>
                                {currentStudyId ?
                                
                                    <li className="active">
                                        <span>Overreading Administration</span>
                                        <ul aria-expanded="false">
                                            <Authorization currentPermissions={currentUserPermissions} studyId={currentStudyId} permissionId={PermissionEnum.ViewFixedComments}>
                                                <li>
                                                    <Link id="fixedCommentsLink" to="/FixedComments"><i className="fas fa-comment-dots fa-lg"></i>&nbsp;Fixed Comments Mangement</Link>
                                                </li>
                                            </Authorization>
                                        </ul>
                                    </li>                           
                                    : null}
                                    <li className="active">
                                        <span>Device Management</span>
                                        <ul>
                                        {currentStudyId ?
                                            <Authorization currentPermissions={currentUserPermissions} studyId={currentStudyId} permissionId={PermissionEnum.ViewDevices}>
                                                    <li>
                                                        <Link id="deviceAdministrationLink" to="/deviceadministration"><i className="fas fa-tablet fa-lg"></i>&nbsp;Device Administration</Link>
                                                    </li>
                                            </Authorization> : null}
                                        <Authorization currentPermissions={currentUserPermissions} studyId={currentStudyId} permissionId={PermissionEnum.ViewDeviceResources}>
                                                    <li>
                                                        <Link to="/UpdatePackages" id="updatePackagesLink">
                                                            <i className="fas fa-database fa-lg"></i>&nbsp;Packages
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/serviceresources" id="serviceResourceLink">
                                                            <i className="fas fa-database fa-lg"></i>&nbsp;Services Resources
                                                        </Link>
                                                    </li>
                                            </Authorization>
                                        <Authorization currentPermissions={currentUserPermissions} studyId={currentStudyId} permissionId={PermissionEnum.ViewEDiaryConfigurations}>
                                                    <li>
                                                        <Link to="/DiaryConfigurations" id="eDiaryConfigurationsLink">
                                                            <i className="fas fa-tablet fa-lg"></i>&nbsp;Diary Configurations
                                                        </Link>
                                                    </li>
                                            </Authorization>
                                        </ul>
                                    </li>
                                {currentStudyId ?
                                    <li className="active">
                                        <span>Technical Support Management</span>
                                        <ul>
                                            <Authorization currentPermissions={currentUserPermissions} studyId={currentStudyId} permissionId={PermissionEnum.EditSupportContactInformationAdministration}>
                                                <li>
                                                    <Link to="/admin/editcontact" id="supportContactLink">
                                                        <i className="fas fa-phone fa-lg"></i>&nbsp;
                                                        Support Contact Information
                                                    </Link>
                                                </li>
                                            </Authorization>
                                        </ul>
                                    </li> : null}
                                <Authorization studyId={currentStudyId} currentPermissions={currentUserPermissions} permissionId={PermissionEnum.AccessHangfire}>
                                    <li className="active">
                                        <span>Job Management</span>
                                        <ul aria-expanded="false">
                                            <li>
                                                <a href="/hangfire" id="hangfireJobsLink">
                                                    <i className="fas fa-list-alt fa-lg"></i>&nbsp;
                                                    Hangfire Jobs
                                                </a>
                                            </li>
                                        </ul>
                                    </li>
                                </Authorization>
                                <Authorization studyId={currentStudyId} currentPermissions={currentUserPermissions} permissionId={PermissionEnum.ViewAuditTrail}>
                                    <li className="active">
                                        <span>Audit</span>
                                        <ul aria-expanded="false">
                                            <li>
                                                <Link to="/Audit" id="auditTrailLink">
                                                    <i className="fas fa-file fa-lg"></i>&nbsp;
                                                    Audit Trail
                                                </Link>
                                            </li>
                                        </ul>
                                    </li>
                                </Authorization>
                            </ul>
                        </div>
                    </nav>
                </div>
                <div className="col-sm-10">
                    <Route exact path="/admin" component={AdminHome} />
                    <Route path="/requests" component={AccessRequestListScreen} />
                    <Route exact path="/users/create" component={CreateUserScreen} />
                    <Route path="/users/edit/:id" component={EditUserScreen} />
                    <Route path="/users/associate" component={AssociateUsersWithSites} />
                    <Route exact path="/users" component={UserList} />                
                    <Route path="/rolemanagement" component={RolesRoot} />
                    <Route path="/VisitSchedule/:studyId" component={VisitSchedule} />
                    <Route exact path="/DiaryConfigurations" component={DiaryConfigurationsList} />
                    <Route exact path="/DiaryConfigurations/Create" component={CreateDiaryConfigurationScreen} />
                    <Route path="/DiaryConfigurations/Edit/:id" component={EditDiaryConfigurationScreen} />
                    <Route path="/DiaryConfigurations/Files/:configId" component={DiaryConfigurationFiles} />
                    <Route path="/FixedComments" component={FixedCommentsScreen} exact={true}/>
                    <Route path="/FixedComments/Create" component={CreateFixedCommentSetScreen} exact={true} />
                    <Route path="/FixedComments/Edit/:id" component={EditFixedCommentSetScreen} exact={true} />
                    <Route exact path="/deviceadministration" component={DevicesList} />
                    <Route path="/deviceadministration/create" component={CreateDeviceScreen} />
                    <Route path="/deviceadministration/edit/:id" component={EditDeviceScreen} />
                    <Route path="/UpdatePackages" component={UpdatePackagesList} />
                    <Route path="/studies" component={StudiesScreen} />
                    <Route path="/sites" component={SiteScreen} />
                    <Route path="/admin/editcontact" component={SupportContactScreen} exact={true} />
                    <Route path="/serviceresources" component={ServiceResourcesList} />
                    <Route path="/admin/notifications" component={NotificationsPanel} />
                    <Route path="/admin/customcalculations" component={CustomCalculationsScreen} />
                </div>
            </div>
        </GlobalAuthorization>
    );
}

function mapStateToProps(state: MainState): AdminMenuLayoutProps {
    return {
        currentStudyId: state.security.studyId
    };
}

export default connect<AdminMenuLayoutProps, any, void>(mapStateToProps)(
    AdminMenuLayout
);

